import BaseApi from '../base/base'
import Inquiry from '../../models/inquiry'
import UserInquiryForm from '../../forms/user_inquiry'

export default class InquiryApi extends BaseApi {
  constructor() {
    super()
    this.path = '/inquiries'
  }

  async index(params = {}) {
    this.path = '/inquiries'
    const response = await this.getRequest(params)
    return response.data.map((element) => new Inquiry(element))
  }

  async show(inquiryId: string, params = {}) {
    this.path = `/inquiries/${inquiryId}`
    const response = await this.getRequest(params)
    return new Inquiry(response.data)
  }

  async delete(inquiryId: number, params = {}) {
    this.path = `/inquiries/${inquiryId}`
    const response = await this.deleteRequest(params)
    return true
  }

  async create(userInquiryForm: UserInquiryForm) {
    this.path = '/inquiries'
    const response = await this.postFormData(userInquiryForm.toFormData())
    return new Inquiry(response.data)
  }

  async update(inquiryId: number, userInquiryForm: UserInquiryForm) {
    this.path = `/inquiries/${inquiryId}`
    const response = await this.putFormData(userInquiryForm.toFormData())
    return new Inquiry(response.data)
  }
}
